import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setConnectedInfo } from '../../store/redux/EQconnect/EQConnectSlice';
import BasicButton from 'view/components/_atom/button/BasicButton';
import { ButtonSize, ButtonTheme } from 'view/components/_atom/button/StyledButton';
import './EQConnectWalletButtonWithMetamask.scss';
import { logic } from '../../logic';
import { ConnectedWallet, Kit } from '../../view/assets/constant/kit.type';
import ConnectWalletModal from '../../view/service/tokenization/components/ConnectWalletModal';
import OwnerBadge from '../../view/service/tokenization/components/OwnerBadge';
import { ReactComponent as IconCopy } from '../../view/assets/images/icon_copy.svg';
import toast from 'react-hot-toast';
import { add } from 'lodash';

type EQConnectWalletButtonWithMetamaskProps = {
  connectedWallet: ConnectedWallet;
  setConnectedWallet: (connectedWallet: ConnectedWallet) => void;
  kitDetail?: Kit;
  type?: 'default' | 'compact';
};
const EQConnectWalletButtonWithMetamask = (props: EQConnectWalletButtonWithMetamaskProps) => {
  const { connectedWallet, setConnectedWallet, kitDetail, type = 'default' } = props;
  const { connectAddress: address } = connectedWallet || {};
  const dispatch = useDispatch();
  const isConnected = useMemo(() => Boolean(address), [address]);

  const getAddress = async () => {
    const { result, error } = await logic.wallet.getConnectWalletData();
    if (error) {
      return;
    }
    setConnectedWallet({ ...result, accountId: result?.accountId || undefined });
  };
  useEffect(() => {
    getAddress();
    window.addEventListener('message', getAddress);
    return () => {
      window.removeEventListener('message', getAddress);
    };
  }, []);

  const disconnectWallet = async () => {
    const { error } = await logic.wallet.disconnectWallet();
    if (error) {
      return;
    }
    setConnectedWallet({ connectWalletType: '', connectAddress: '', accountId: undefined, accountName: null });
  };
  useEffect(() => {
    const sessionAddress = sessionStorage.getItem('address');
    const sessionType = sessionStorage.getItem('type');
    dispatch(
      setConnectedInfo({
        address: sessionAddress,
        type: sessionType,
      })
    );
    window.addEventListener('disconnect', () => {
      disconnectWallet();
    });
    return () => {
      window.removeEventListener('disconnect', () => {
        disconnectWallet();
      });
    };
  }, []);

  const [isOpenConnectWalletModal, setIsOpenConnectWalletModal] = useState(false);

  const disconnect = async (e: React.MouseEvent<any>) => {
    e.preventDefault();
    e.stopPropagation();
    const disconnectEvent = new CustomEvent('disconnect');
    window.dispatchEvent(disconnectEvent);
    await disconnectWallet();
    toast.success('Disconnected!');
  };
  const onClickButton = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isConnected) {
      setIsOpenConnectWalletModal(true);
    } else {
      if (type === 'compact') {
        await disconnect(e);
        return;
      }
      await navigator.clipboard.writeText(address);
      toast('Address Copied', { icon: '👏' });
    }
  };
  const [isFocusing, setIsFocusing] = useState(false);
  const connectButtonRenderer = useMemo(() => {
    if (Boolean(address)) {
      return (
        <>
          <div className="connected-address-wrapper">
            {kitDetail?.admin_address === address && <OwnerBadge />}
            <div
              style={{
                fontWeight: 500,
                fontSize: 16,
                lineHeight: '30px',
                color: '#3F4248',
              }}
            >{`${address.slice(0, 5)}...${address.slice(-4)}`}</div>
            <IconCopy style={{ minWidth: 16, minHeight: 16, objectFit: 'contain', cursor: 'pointer' }} className="icon-copy" />
          </div>
          {isFocusing && (
            <div className="connected-address-menu-wrapper">
              <div className="connected-address-menu-item" onClick={disconnect}>
                Disconnect
              </div>
            </div>
          )}
        </>
      );
    } else {
      return <div>Connect Wallet</div>;
    }
  }, [address, isFocusing]);

  return (
    <>
      <ConnectWalletModal
        isOpen={isOpenConnectWalletModal}
        closeModal={() => setIsOpenConnectWalletModal(false)}
        setConnectedWallet={setConnectedWallet}
        kitDetail={kitDetail}
      />
      {/*<SelectWalletModal isOpen={isOpenSelectWalletModal} closeModal={() => setIsOpenSelectWalletModal(false)} getAddress={getAddress} />*/}
      {type === 'compact' ? (
        <BasicButton
          size={ButtonSize.DYNAMIC}
          style={{ width: 'fit-content' }}
          theme={address ? ButtonTheme.NORMAL : ButtonTheme.PRIMARY}
          onClick={onClickButton}
          onMouseEnter={() => setIsFocusing(true)}
          onMouseLeave={() => setIsFocusing(false)}
          useActiveEffect={false}
        >
          {address ? 'Disconnect' : 'Connect Wallet'}
        </BasicButton>
      ) : (
        <BasicButton
          size={ButtonSize.MIDDLE}
          style={{ border: 'none', position: 'relative' }}
          theme={address ? ButtonTheme.SECONDARY : ButtonTheme.PRIMARY}
          onClick={onClickButton}
          onMouseEnter={() => setIsFocusing(true)}
          onMouseLeave={() => setIsFocusing(false)}
          useActiveEffect={false}
        >
          {connectButtonRenderer}
        </BasicButton>
      )}
    </>
  );
};

export default EQConnectWalletButtonWithMetamask;

// export const enum WalletType {
//   metaMask = 'metamask',
//   eqHub = 'eqhub',
// }
//
// const WALLETS = [
//   {
//     type: WalletType.metaMask,
//     img: metamaskLogo,
//   },
//   {
//     type: WalletType.eqHub,
//     img: eqWalletLogo,
//   },
// ];
// type SelectWalletModalProps = {
//   isOpen: boolean;
//   closeModal: () => void;
//   getAddress: () => void;
// };
// const SelectWalletModal = (props: SelectWalletModalProps) => {
//   const { isOpen, closeModal, getAddress } = props;
//
//   return (
//     <Modal
//       isOpen={isOpen}
//       onRequestClose={closeModal}
//       style={customStyles}
//       overlayClassName="modal-overlay-style"
//       ariaHideApp={false}
//       shouldCloseOnOverlayClick={true}
//     >
//       <div className="connect-wallet-modal">
//         <div className="connect-wallet-modal-header">Connect Your Wallet</div>
//         <div className="connect-wallet-modal-content">
//           {WALLETS.map((wallet) => (
//             <div
//               key={wallet.type}
//               className="connect-wallet-modal-content-button"
//               onClick={async () => {
//                 let result: any;
//                 if (wallet.type === WalletType.eqHub) {
//                   result = requestAddressToExtension();
//                 } else {
//                   result = await requestAddressToMetamask(wallet.type);
//                 }
//                 if (result) {
//                   getAddress();
//                 }
//                 closeModal();
//               }}
//             >
//               <img src={wallet.img} alt={wallet.type} className="connect-wallet-modal-content-logo" />
//             </div>
//           ))}
//         </div>
//         <div className="connect-wallet-modal-footer">
//           You don't have a wallet?
//           <a
//             className="connect-wallet-modal-footer-link"
//             href="https://chromewebstore.google.com/detail/eq-hub-wallet/jjkhekbaikcnpnhflnnlnbonkkobkiim?hl=ko&utm_source=ext_sidebar"
//             target="_blank"
//             rel="noreferrer"
//           >
//             Get EQHub wallet
//           </a>
//         </div>
//       </div>
//     </Modal>
//   );
// };
